import moment from 'moment';
import { getOptionConfig, getOptionLabel } from '../../components/DynamicViewNew/helper';
import scl from "../models/scl";

export const types = {
  SCL_REQUEST: "SCL_REQUESTED",
  SCL_DATA: "SCL_DATA",
  SCL_GET_SUCCESS: "SCL_GET_SUCCESS",
  SCL_SUCCESS: "SCL_SUCCESS",
  SCL_FAILED: "SCL_FAILED",
  LOCATION_REQUEST: "LOCATION_REQUEST",
  LOCATION_SUCCESS: "LOCATION_SUCCESS",
  LOCATION_FAILED: "LOCATION_FAILED",
  SCL_RESET: "SCL_RESET",
  SCL_SUBMIT_REQUEST: "SCL_SUBMITTED",
  SCL_SUBMIT_SUCCESS: "SCL_SUBMIT_SUCCESS",
  SCL_SUBMIT_FAILED: "SCL_SUBMIT_FAILED",
  SCL_PUBLISH_REQUEST: "SCL_PUBLISH_REQUEST",
  SCL_PUBLISH_SUCCESS: "SCL_PUBLISH_SUCCESS",
  SCL_PUBLISH_FAILED: "SCL_PUBLISH_FAILED",
  SCL_LINKING: "SCL_LINKING",
  SCL_LINKING_SUCCESS: "SCL_LINKING_SUCCESS",
  SCL_LINKING_FAILED: "SCL_LINKING_FAILED",
  SCL_REMOVE: "SCL_REMOVE",
  SCL_REMOVE_SUCCESS: "SCL_REMOVE_SUCCESS",
  SCL_REMOVE_FAILED: "SCL_REMOVE_FAILED",
  SCL_RISK_SUBMIT_REQUEST: "SCL_RISK_SUBMITTED",
  SCL_RISK_SUBMIT_SUCCESS: "SCL_RISK_SUBMIT_SUCCESS",
  SCL_RISK_SUBMIT_FAILED: "SCL_RISK_SUBMIT_FAILED",
};

export const actions = {
  SCLGet: (params) => {
    return { type: types.SCL_REQUEST, value: params };
  },
  getALL: (params, published = null) => {
    return { type: types.LOCATION_REQUEST, value: params, published };
  },
  SCLDataGet: (payload) => {
    return { type: types.SCL_DATA, value: payload };
  },
  SCLSubmit: (payload, callback = () => { }) => {
    return { type: types.SCL_SUBMIT_REQUEST, value: payload, callback };
  },
  SCLPublish: (sclId, callback = () => { }) => {
    return { type: types.SCL_PUBLISH_REQUEST, value: sclId, callback };
  },
  ResetForm: (module, view) => {
    return { type: types.SCL_RESET, value: { module, view } };
  },
  sclLinking: (payload) => {
    return { type: types.SCL_LINKING, value: payload };
  },
  sclRemove: (payload, callback = () => { }) => {
    return { type: types.SCL_REMOVE, value: payload, callback };
  },
  SCLRiskSubmit: (payload, callback = () => { }, id) => {
    return { type: types.SCL_RISK_SUBMIT_REQUEST, value: payload, callback, id };
  },
};

function setViewConfig(value) {
  const { data, config = { options: {} } } = value;
  if (!data) {
    return {};
  }
  const status = getOptionConfig(config.options.status || [], data.status);
  return {
    title: {
      en: data.locationName || data.name,
      fr: data.locationName || data.name,
    },
    tags: [
      {
        label: {
          en: 'Category',
          fr: 'Catégorie',
        },
        value: getOptionLabel(config.options.category || [], data.category, undefined, data),
        color: 'green',
      },
      {
        label: {
          en: 'Status',
          fr: 'Statut',
        },
        value: status.label,
        color: status.color,
      },
      {
        label: {
          en: 'Last Edit',
          fr: 'Dernière Modification',
        },
        value: moment(data.updatedAt).fromNow(),
        color: 'default',
      },
    ],
  }
}

const reducer = (state = scl, action) => {
  const { data = {} } = state;
  switch (action.type) {
    case types.SCL_REQUEST:
    case types.LOCATION_REQUEST:
      return {
        ...state,
        loading: true
      }
    case types.SCL_GET_SUCCESS:
    case types.LOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...data,
          ...action.value
        }
      }
    case types.SCL_SUCCESS:
      Object.keys(action.value).forEach((k) => {
        data[k] = action.value[k];
      });
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...data,
          ...action.value,
        },
        viewConfig: {
          ...setViewConfig(action.value[Object.keys(action.value)[0]]),
        },
      }
    case types.SCL_SUBMIT_REQUEST:
    case types.SCL_RISK_SUBMIT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SCL_SUBMIT_SUCCESS:
    case types.SCL_RISK_SUBMIT_SUCCESS:
      if (!data[`${action.value.module}-${action.value.view}`]) {
        data[`${action.value.module}-${action.value.view}`] = {}
      }
      data[`${action.value.module}-${action.value.view}`].data = action.value;
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...data,
        },
        viewConfig: {
          ...setViewConfig(data[`${action.value.module}-${action.value.view}`]),
        },
      };
    case types.SCL_SUBMIT_FAILED:
    case types.SCL_RISK_SUBMIT_FAILED:
      return {
        ...state,
        loading: false,
        errors: action.value || null,
      };
    case types.SCL_LINKING_SUCCESS:
      state.data.linking = action.value;
      return {
        ...state,
        data: {
          ...state.data,
        },
        loading: false,
      };
    case types.SCL_PUBLISH_SUCCESS:
      const { module: modu, view: vie, ...fData } = action.value;
      state.data[`${modu}-${vie}`].data = fData;
      return {
        ...state,
        data: {
          ...state.data,
        },
        loading: false,
      };

    case types.SCL_RESET:
      delete state.data[`${action.value.module}-${action.value.view}`];
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
